import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersEventsApi,
  partnersEventsApiKeys,
} from '@/api/routes/partners/partners.events.api';

/** Delete an event nobody confirmed. A 409 (confirmations) goes to the global snackbar. */
export const usePartnersDeleteEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => partnersEventsApi.remove(id),
    onSuccess: (_, id) => {
      queryClient.removeQueries({ queryKey: partnersEventsApiKeys.detail(id) });
      return queryClient.invalidateQueries({ queryKey: partnersEventsApiKeys.all });
    },
  });
};
